function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#596266",
  d: "M12,6 L12,9 L7.5,5 L12,1 L12,3 C16.9705627,3 21,7.02943725 21,12 C21,14.4852814 19.9926407,16.7352814 18.363961,18.363961 L16.2426407,16.2426407 C17.3284271,15.1568542 18,13.6568542 18,12 C18,8.6862915 15.3137085,6 12,6 Z M12,18.003961 L12,15.003961 L16.5,19.003961 L12,23.003961 L12,21.003961 C7.02943725,21.003961 3,16.9745238 3,12.003961 C3,9.51867966 4.00735931,7.26867966 5.63603897,5.64 L7.75735931,7.76132034 C6.67157288,8.84710678 6,10.3471068 6,12.003961 C6,15.3176695 8.6862915,18.003961 12,18.003961 Z"
});

var SvgUpdate = function SvgUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Update.6382d278.svg";
export { ForwardRef as ReactComponent };